import * as React from "react";
import { useFeatureToggles } from "@grandvisionhq/state";
const useIsApplePayActive = () => {
  const { isApplePayExpressCheckoutEnabled } = useFeatureToggles();
  const isApplePayActive = React.useMemo(
    () => isApplePayExpressCheckoutEnabled && typeof ApplePaySession !== "undefined" && ApplePaySession?.canMakePayments?.(),
    [isApplePayExpressCheckoutEnabled]
  );
  return isApplePayActive;
};
export {
  useIsApplePayActive
};
//# sourceMappingURL=use-is-apple-pay-active.js.map
